// @flow
export * from './index.ts';

// Global types
export type * from './types';

// Display Components
export { default as Accordion } from './components/display/Accordion';
export { default as Article } from './components/display/Article';
export { default as AsyncIndicator } from './components/display/AsyncIndicator';
export { default as Avatar } from './components/display/Avatar';
export { default as Badge } from './components/display/Badge';
export { default as FloatingBox } from './components/display/FloatingBox';
export { default as TagLabel } from './components/display/TagLabel';
export { default as Surface } from './components/display/Surface';
export { default as Heading, HeadingLevel } from './components/display/Heading';
export { default as Icon, iconsMap } from './components/display/Icon';
export type { IconProps } from './components/display/Icon';
// export { default as Img } from './components/display/Img';
export { default as ProgressBar } from './components/display/ProgressBar';
export { default as Spinner } from './components/display/Spinner';
export { default as Text } from './components/display/Text';
export { default as Tooltip } from './components/display/Tooltip';
export type { TooltipPosition } from './components/display/Tooltip';
export { default as TooltipWrapper } from './components/display/TooltipWrapper';

// Form Components
export {
  default as BooleanInput,
  Checkbox,
  Radio,
  LabeledCheckbox,
  LabeledRadio,
} from './components/forms/BooleanInput';
export { default as Dropdown } from './components/forms/Dropdown';
export type { DropdownProps } from './components/forms/Dropdown';
export { default as Field } from './components/forms/Field';
export type * from './components/forms/Field';
export {
  default as FormLabel,
  FormLabelRequiredText,
} from './components/forms/FormLabel';
export { default as FloatingMenu } from './components/forms/FloatingMenu';
export { default as Input } from './components/forms/Input';
export type { InputProps } from './components/forms/Input';
export { default as Menu, MenuItem } from './components/forms/Menu';
export { default as TextInput } from './components/forms/TextInput';
export type * from './components/forms/TextInput';
export { default as ToggleSwitch } from './components/forms/ToggleSwitch';
export { default as Typeahead } from './components/forms/Typeahead';

// Navigation Components
export {
  default as Button,
  ButtonColors as DefaultButtonColors,
} from './components/navigation/Button';
export type * from './components/navigation/Button';
export { default as ButtonNav } from './components/navigation/ButtonNav';
export type {
  ButtonNavItemType,
  ButtonNavOnChooseItem,
} from './components/navigation/ButtonNav/types';
export { default as IconButton } from './components/navigation/IconButton';
export { default as Indicator } from './components/navigation/Indicator';
export { default as LoadMoreBar } from './components/navigation/LoadMoreBar';
export {
  default as Paginator,
  PaginatorStateful,
} from './components/navigation/Paginator';
export type { OnPaginateData } from './components/navigation/Paginator';
export { default as Nav, AutoNav } from './components/navigation/Nav';
export type * from './components/navigation/Nav/types';

export * from './flow-types.js';
